// export const BASE_URL="https://killcode.myrealms.in/";
export const BASE_URL=process.env.REACT_APP_API_BASE || "http://localhost:8000/";
